var _defs, _g, _g2, _g3, _g4, _g5, _path, _path2, _path3, _g6, _path4, _path5, _path6, _g7, _g8, _g9, _g10, _g11, _g12, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTracks({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 545.687,
    height: 418.474,
    viewBox: "0 0 545.687 418.474",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Path_308",
    x: 76.658,
    y: 41,
    width: 396,
    height: 349.438,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x2: 1,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#07c87a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00baef"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 0.689,
    y1: 0.238,
    x2: 0.063,
    y2: 0.775,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00baef"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#07c87a"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Path_385",
    x: 286.687,
    y: 9,
    width: 259,
    height: 71,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur-2"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-2"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0b7ce3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8338ec"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: -0.309,
    y1: 1.232,
    x2: 1.723,
    y2: 0.813,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fa8800"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e31926"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 0.332,
    y1: 0.613,
    x2: 1,
    y2: 0.222,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: 0.169,
    y1: 0.78,
    x2: 1.148,
    y2: 0.199,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fed700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e31926"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Path_461",
    x: 377.687,
    y: 288,
    width: 108,
    height: 117.56,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur-3"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-3"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: 0.52,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fb3780"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.178,
    stopColor: "#fb4569"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fa8800"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: 1.184,
    y1: -0.157,
    x2: -0.049,
    y2: 1.054,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#333"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.115,
    stopColor: "#333"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.903,
    stopColor: "#7e38e1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8338ec"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-10",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffe200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fa8800"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-11",
    x1: 0.912,
    y1: 0.248,
    x2: -0.181,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00baef"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "tracks_graphic",
    "data-name": "tracks graphic",
    transform: "translate(-6.313 424)"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 6.31, -424)",
    filter: "url(#Path_308)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_308-2",
    "data-name": "Path 308",
    d: "M91.971-377h378V-45.562h-378Z",
    transform: "translate(-6.31 424)",
    fill: "#fff"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "text"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_313",
    "data-name": "Path 313",
    d: "M217.695-147.687H369.707a5,5,0,0,1,5,5v84.813a5,5,0,0,1-5,5H217.695a5,5,0,0,1-5-5v-84.812A5,5,0,0,1,217.695-147.687Z",
    fill: "#f4f4f4",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_316",
    "data-name": "Path 316",
    d: "M374.707-138.437H212.695v-6.25a3,3,0,0,1,3-3H371.707a3,3,0,0,1,3,3v6.25Z",
    fill: "#cfd1d2",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_319",
    "data-name": "Path 319",
    d: "M234.367-129.187h90.893a2,2,0,0,1,2,2V-115a2,2,0,0,1-2,2H234.367a2,2,0,0,1-2-2v-12.187A2,2,0,0,1,234.367-129.187Z",
    fill: "#cfd1d2",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_322",
    "data-name": "Path 322",
    d: "M234.367-103.75h90.893a2,2,0,0,1,2,2v9.875a2,2,0,0,1-2,2H234.367a2,2,0,0,1-2-2v-9.875A2,2,0,0,1,234.367-103.75Z",
    fill: "#cfd1d2",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_325",
    "data-name": "Path 325",
    d: "M234.367-80.625h90.893a2,2,0,0,1,2,2v17.969a2,2,0,0,1-2,2H234.367a2,2,0,0,1-2-2V-78.625A2,2,0,0,1,234.367-80.625Z",
    fill: "#cfd1d2",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_328",
    "data-name": "Path 328",
    d: "M225.424-122.25a3.47,3.47,0,0,0,3.472-3.469,3.47,3.47,0,0,0-3.472-3.469,3.47,3.47,0,0,0-3.472,3.469A3.47,3.47,0,0,0,225.424-122.25Z",
    fill: "#cfd1d2",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_331",
    "data-name": "Path 331",
    d: "M225.424-96.812a3.47,3.47,0,0,0,3.472-3.469,3.47,3.47,0,0,0-3.472-3.469,3.47,3.47,0,0,0-3.472,3.469A3.47,3.47,0,0,0,225.424-96.812Z",
    fill: "#cfd1d2",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_334",
    "data-name": "Path 334",
    d: "M225.424-73.687a3.47,3.47,0,0,0,3.472-3.469,3.47,3.47,0,0,0-3.472-3.469,3.47,3.47,0,0,0-3.472,3.469A3.47,3.47,0,0,0,225.424-73.687Z",
    fill: "#cfd1d2",
    fillRule: "evenodd"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "video"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_337",
    "data-name": "Path 337",
    d: "M215.695-307.25H371.707a3,3,0,0,1,3,3v62.219a3,3,0,0,1-3,3H215.695a3,3,0,0,1-3-3V-304.25A3,3,0,0,1,215.695-307.25Z",
    fillRule: "evenodd",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_340",
    "data-name": "Path 340",
    d: "M299.1-272.766h0a3.966,3.966,0,0,0-.687-.744q-4.539-2.723-9.109-5.4c-.759-.449-1.364-.134-1.364.744q-.046,5.427,0,10.854c0,.884.605,1.224,1.362.774q4.606-2.692,9.175-5.445c.224-.145.357-.457.626-.78Z",
    fill: "#fff",
    fillRule: "evenodd"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "description"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_343",
    "data-name": "Path 343",
    d: "M215.695-227.469H374.022a3,3,0,0,1,3,3v58.75a3,3,0,0,1-3,3H215.695a3,3,0,0,1-3-3v-58.75A3,3,0,0,1,215.695-227.469Z",
    fill: "#f4f4f4",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_346",
    "data-name": "Path 346",
    d: "M220.638-215.906H366.764a1,1,0,0,1,1,1v1.469a1,1,0,0,1-1,1H220.638a1,1,0,0,1-1-1v-1.469A1,1,0,0,1,220.638-215.906Z",
    fill: "#d0d1d3",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_349",
    "data-name": "Path 349",
    d: "M220.638-204.344h141.5a1,1,0,0,1,1,1v1.469a1,1,0,0,1-1,1h-141.5a1,1,0,0,1-1-1v-1.469A1,1,0,0,1,220.638-204.344Z",
    fill: "#d0d1d3",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_352",
    "data-name": "Path 352",
    d: "M220.638-192.781H334.361a1,1,0,0,1,1,1v1.469a1,1,0,0,1-1,1H220.638a1,1,0,0,1-1-1v-1.469A1,1,0,0,1,220.638-192.781Z",
    fill: "#d0d1d3",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_355",
    "data-name": "Path 355",
    d: "M220.638-178.906h38.5a1,1,0,0,1,1,1v7.25a1,1,0,0,1-1,1h-38.5a1,1,0,0,1-1-1v-7.25A1,1,0,0,1,220.638-178.906Z",
    fill: "#fb3780",
    fillRule: "evenodd"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "nav"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_369",
    "data-name": "Path 369",
    d: "M96.971-39H197.65V-360.437H96.971Z",
    transform: "translate(-4 -1)",
    fill: "#f4f4f4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_372",
    "data-name": "Path 372",
    d: "M107.229-293.375h69.748a1,1,0,0,1,1,1v.313a1,1,0,0,1-1,1H107.229a1,1,0,0,1-1-1v-.312A1,1,0,0,1,107.229-293.375Z",
    fill: "#cfd1d2",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_375",
    "data-name": "Path 375",
    d: "M107.229-337.312h69.748a1,1,0,0,1,1,1v16.5a1,1,0,0,1-1,1H107.229a1,1,0,0,1-1-1v-16.5A1,1,0,0,1,107.229-337.312Z",
    fill: "#cfd1d2",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_378",
    "data-name": "Path 378",
    d: "M107.229-251.75h69.748a1,1,0,0,1,1,1v.313a1,1,0,0,1-1,1H107.229a1,1,0,0,1-1-1v-.312A1,1,0,0,1,107.229-251.75Z",
    fill: "#cfd1d2",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_381",
    "data-name": "Path 381",
    d: "M107.229-230.937h69.748a1,1,0,0,1,1,1v.313a1,1,0,0,1-1,1H107.229a1,1,0,0,1-1-1v-.312A1,1,0,0,1,107.229-230.937Z",
    fill: "#cfd1d2",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_384",
    "data-name": "Path 384",
    d: "M107.229-272.562h69.748a1,1,0,0,1,1,1v.313a1,1,0,0,1-1,1H107.229a1,1,0,0,1-1-1v-.312A1,1,0,0,1,107.229-272.562Z",
    fill: "#cfd1d2",
    fillRule: "evenodd"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "title",
    d: "M213.38-332.687H371.707c1.657,0,3,2.357,3,5.264v11.789c0,2.907-1.343,5.264-3,5.264H213.38c-1.657,0-3-2.357-3-5.264v-11.789C210.38-330.331,211.723-332.687,213.38-332.687Z",
    transform: "translate(0 -8)",
    fill: "#f4f4f4",
    fillRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "sidebar",
    d: "M404.592-332.687h47.623c3.723,0,6.741,4.11,6.741,9.18v241.7c0,5.07-3.018,9.18-6.741,9.18H404.592c-3.723,0-6.741-4.11-6.741-9.18v-241.7C397.852-328.577,400.87-332.687,404.592-332.687Z",
    transform: "translate(0 -8)",
    fill: "#f4f4f4",
    fillRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "header",
    d: "M469.971-349.474h-373v-19.279A3.149,3.149,0,0,1,100.012-372H466.931a3.149,3.149,0,0,1,3.041,3.247v19.279Z",
    transform: "translate(0 -6)",
    fillRule: "evenodd",
    fill: "url(#linear-gradient-2)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "progresss",
    style: {
      isolation: "isolate"
    }
  }, _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 6.31, -424)",
    filter: "url(#Path_385)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_385-2",
    "data-name": "Path 385",
    d: "M302-409H543v53H302Z",
    transform: "translate(-6.31 424)",
    fill: "#fff"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_390",
    "data-name": "Path 390",
    d: "M327.266-391.216H427.644a8.716,8.716,0,0,1,8.716,8.716,8.716,8.716,0,0,1-8.716,8.716H327.266a8.716,8.716,0,0,1-8.716-8.716A8.716,8.716,0,0,1,327.266-391.216Z",
    fill: "#f2f3f4",
    fillRule: "evenodd"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_393",
    "data-name": "Path 393",
    d: "M327.266-391.216H380.52a8.716,8.716,0,0,1,8.716,8.716,8.716,8.716,0,0,1-8.716,8.716H327.266a8.716,8.716,0,0,1-8.716-8.716A8.716,8.716,0,0,1,327.266-391.216Z",
    fillRule: "evenodd",
    fill: "url(#linear-gradient-3)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_396",
    "data-name": "Path 396",
    d: "M465.939-372.622a8.777,8.777,0,0,1-4.022-.878,6.492,6.492,0,0,1-2.672-2.415,6.489,6.489,0,0,1-.941-3.457,9.291,9.291,0,0,1,2.127-5.323l4.962-6.86a2.166,2.166,0,0,1,.409-.412.926.926,0,0,1,.545-.137h2.59a.491.491,0,0,1,.4.178.64.64,0,0,1,.15.425.633.633,0,0,1-.109.357l-3.817,5.3a4.85,4.85,0,0,1,1.145-.11,6.985,6.985,0,0,1,3.367.892,6.661,6.661,0,0,1,2.454,2.346,6.151,6.151,0,0,1,.913,3.293,6.607,6.607,0,0,1-.913,3.416,6.586,6.586,0,0,1-2.617,2.47A8.229,8.229,0,0,1,465.939-372.622Zm-.055-3.183a3.757,3.757,0,0,0,2.59-.947,3.328,3.328,0,0,0,1.063-2.62,3.315,3.315,0,0,0-1.05-2.593,3.744,3.744,0,0,0-2.6-.947,3.707,3.707,0,0,0-2.577.947,3.316,3.316,0,0,0-1.05,2.593,3.349,3.349,0,0,0,1.05,2.62A3.707,3.707,0,0,0,465.885-375.8Zm17.422,3.183q-3.654,0-5.439-2.031a8.43,8.43,0,0,1-1.949-5.323q-.027-.741-.027-2.525,0-1.811.027-2.579a8.114,8.114,0,0,1,1.963-5.268,6.926,6.926,0,0,1,5.426-2.031,6.927,6.927,0,0,1,5.426,2.031,8.114,8.114,0,0,1,1.963,5.268q.055,1.537.055,2.579t-.055,2.525a8.43,8.43,0,0,1-1.949,5.323Q486.961-372.622,483.307-372.622Zm0-3.21a2.985,2.985,0,0,0,2.536-1.111,5.4,5.4,0,0,0,.9-3.169q.027-.8.027-2.442t-.027-2.387a5.363,5.363,0,0,0-.9-3.128,3.036,3.036,0,0,0-2.536-1.152,3.036,3.036,0,0,0-2.536,1.152,5.362,5.362,0,0,0-.9,3.128q-.027.741-.027,2.387t.027,2.442a5.4,5.4,0,0,0,.9,3.169A2.985,2.985,0,0,0,483.307-375.832Zm14.232-6.613a4.162,4.162,0,0,1-2.877-.96,3.661,3.661,0,0,1-1.186-2.607q-.027-.467-.027-1.235,0-.823.027-1.317a3.9,3.9,0,0,1,1.145-2.689,4.059,4.059,0,0,1,2.917-.988,4.109,4.109,0,0,1,2.931.988,3.875,3.875,0,0,1,1.159,2.689q.054.988.055,1.317,0,.3-.055,1.235a3.661,3.661,0,0,1-1.186,2.607A4.2,4.2,0,0,1,497.54-382.445Zm-2.209,9.549a.618.618,0,0,1-.436-.151.516.516,0,0,1-.164-.4.474.474,0,0,1,.109-.3l13.442-17.836a1.812,1.812,0,0,1,.409-.4,1,1,0,0,1,.545-.124h1.445a.569.569,0,0,1,.423.151.54.54,0,0,1,.15.4.474.474,0,0,1-.109.3L497.7-373.417a1.812,1.812,0,0,1-.409.4.945.945,0,0,1-.518.124ZM497.54-384.5a1.386,1.386,0,0,0,1.159-.466,2.282,2.282,0,0,0,.45-1.18q.054-.933.055-1.152,0-.3-.055-1.125a2.13,2.13,0,0,0-.436-1.194,1.407,1.407,0,0,0-1.172-.48,1.374,1.374,0,0,0-1.145.48,2.13,2.13,0,0,0-.436,1.194q-.027.412-.027,1.125,0,.686.027,1.152a2.152,2.152,0,0,0,.423,1.166A1.367,1.367,0,0,0,497.54-384.5Zm10.906,11.772a4.055,4.055,0,0,1-2.876-1,3.84,3.84,0,0,1-1.186-2.675q-.027-.467-.027-1.235,0-.8.027-1.29a3.9,3.9,0,0,1,1.145-2.689,4.059,4.059,0,0,1,2.917-.988,4.1,4.1,0,0,1,2.945.988,3.9,3.9,0,0,1,1.145,2.689q.054.988.055,1.29t-.055,1.235a3.84,3.84,0,0,1-1.186,2.675A4.094,4.094,0,0,1,508.446-372.731Zm0-2.14a1.4,1.4,0,0,0,1.186-.48,2.151,2.151,0,0,0,.423-1.166q.055-.933.055-1.18,0-.274-.055-1.1a2.129,2.129,0,0,0-.436-1.194,1.407,1.407,0,0,0-1.172-.48,1.374,1.374,0,0,0-1.145.48,2.13,2.13,0,0,0-.436,1.194q-.027.412-.027,1.1,0,.713.027,1.18a2.152,2.152,0,0,0,.423,1.166A1.367,1.367,0,0,0,508.446-374.872Z",
    fill: "url(#linear-gradient-3)"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "clock"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_402",
    "data-name": "Path 402",
    d: "M461.333-330.911h9.882V-337.5h-9.882Z",
    fill: "#ec4517"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_405",
    "data-name": "Path 405",
    d: "M466-284.6c12.887,0,23.333-10.812,23.333-24.15S478.887-332.9,466-332.9s-23.333,10.812-23.333,24.15S453.113-284.6,466-284.6Z",
    fill: "#f4f4f4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_408",
    "data-name": "Path 408",
    d: "M464.837-304.352a5.333,5.333,0,0,0,6.529-1.173c1.41-1.819.77-4.235-1.428-5.411a5.338,5.338,0,0,0-6.531,1.185c-1.408,1.817-.772,4.238,1.43,5.4",
    fill: "#253137"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_411",
    "data-name": "Path 411",
    d: "M450.149-316.8l17.614,6.262-3.4,4.384Z",
    fill: "#253137"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_414",
    "data-name": "Path 414",
    d: "M464.208-306.63a1.171,1.171,0,0,0,1.606-.353,1.131,1.131,0,0,0-.353-1.583,1.176,1.176,0,0,0-1.612.343,1.144,1.144,0,0,0,.358,1.593",
    fill: "#9ea7da"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_417",
    "data-name": "Path 417",
    d: "M467-333.944c-.659-.044-1.312-.106-1.972-.106-.521,0-1.032.055-1.55.083v8.734H467Z",
    fill: "#90a4ad"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_420",
    "data-name": "Path 420",
    d: "M467-289.861c-.659-.044-1.312-.106-1.972-.106-.521,0-1.032.055-1.55.083v8.734H467Z",
    fill: "#90a4ad"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_423",
    "data-name": "Path 423",
    d: "M438.926-305.837c-.044-.659-.106-1.314-.106-1.975,0-.522.055-1.033.083-1.552h8.722v3.527Z",
    fill: "#90a4ad"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_426",
    "data-name": "Path 426",
    d: "M482.951-305.837c-.044-.659-.106-1.314-.106-1.975,0-.522.055-1.033.083-1.552h8.722v3.527Z",
    fill: "#90a4ad"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_429",
    "data-name": "Path 429",
    d: "M479.815-329.6c-.551-.367-1.087-.742-1.661-1.07-.453-.258-.921-.464-1.386-.7l-4.325,7.584,3.057,1.749Z",
    fill: "#90a4ad"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_432",
    "data-name": "Path 432",
    d: "M457.978-291.324c-.549-.365-1.086-.742-1.659-1.069-.454-.259-.923-.465-1.388-.7l-4.325,7.584,3.057,1.749Z",
    fill: "#90a4ad"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_435",
    "data-name": "Path 435",
    d: "M479.745-297.272c.287-.594.558-1.194.887-1.767.257-.453.558-.869.84-1.307l7.576,4.333-1.747,3.061Z",
    fill: "#90a4ad"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_438",
    "data-name": "Path 438",
    d: "M488.62-319.806c-.306-.587-.593-1.176-.937-1.742-.271-.444-.585-.85-.877-1.282l-7.447,4.546,1.833,3.012Z",
    fill: "#90a4ad"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_441",
    "data-name": "Path 441",
    d: "M451.026-296.863c-.3-.585-.594-1.176-.937-1.739-.271-.448-.583-.853-.877-1.284l-7.447,4.546,1.833,3.012Z",
    fill: "#90a4ad"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_444",
    "data-name": "Path 444",
    d: "M450.038-329.18c.541-.379,1.065-.772,1.631-1.116.445-.272.91-.49,1.367-.737l4.538,7.457-3.008,1.834Z",
    fill: "#90a4ad"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_447",
    "data-name": "Path 447",
    d: "M472.952-291.536c.539-.381,1.064-.774,1.631-1.118.444-.272.909-.49,1.365-.739l4.54,7.459L477.48-284.1Z",
    fill: "#90a4ad"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_450",
    "data-name": "Path 450",
    d: "M489.542-329.2a1.721,1.721,0,0,1-2.424.257l-5.363-4.338a1.725,1.725,0,0,1-.257-2.425l3.254-4.024a1.72,1.72,0,0,1,2.424-.257l5.363,4.338a1.723,1.723,0,0,1,.257,2.425Z",
    fill: "url(#linear-gradient-5)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_453",
    "data-name": "Path 453",
    d: "M465.589-335.2A27.6,27.6,0,0,0,438-307.6,27.6,27.6,0,0,0,465.589-280a27.6,27.6,0,0,0,27.59-27.6A27.6,27.6,0,0,0,465.589-335.2Zm0,50.025A22.418,22.418,0,0,1,443.173-307.6a22.419,22.419,0,0,1,22.416-22.425A22.419,22.419,0,0,1,488.006-307.6,22.418,22.418,0,0,1,465.589-285.175Z",
    fill: "url(#linear-gradient-6)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_456",
    "data-name": "Path 456",
    d: "M474.211-340.375a1.723,1.723,0,0,1-1.724,1.725H458.692a1.723,1.723,0,0,1-1.724-1.725v-6.9A1.723,1.723,0,0,1,458.692-349h13.795a1.723,1.723,0,0,1,1.724,1.725Z",
    fill: "url(#linear-gradient-7)"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "track",
    transform: "translate(22 38)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -15.69, -462)",
    filter: "url(#Path_461)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_461-2",
    "data-name": "Path 461",
    d: "M373.015-168h85.97A1.935,1.935,0,0,1,461-166.156v95.872a1.935,1.935,0,0,1-2.015,1.844h-85.97A1.935,1.935,0,0,1,371-70.284v-95.872A1.935,1.935,0,0,1,373.015-168Z",
    transform: "translate(15.69 462)",
    fill: "#fff",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_464",
    "data-name": "Path 464",
    d: "M373.015-168h85.97A1.991,1.991,0,0,1,461-166.034v51.115H371v-51.115A1.991,1.991,0,0,1,373.015-168Z",
    transform: "translate(0 -1)",
    fillRule: "evenodd",
    fill: "url(#linear-gradient-8)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_470",
    "data-name": "Path 470",
    d: "M385.568-32.614h60.864c1.666,0,3.016,2.239,3.016,5v6.2c0,2.761-1.35,5-3.016,5H385.568c-1.666,0-3.016-2.239-3.016-5v-6.2C382.552-30.376,383.9-32.614,385.568-32.614Z",
    transform: "translate(-1 -60.12)",
    fill: "#f4f4f4",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_473",
    "data-name": "Path 473",
    d: "M383.151-76.586h64.543c.331,0,.6.448.6,1v2.629c0,.552-.268,1-.6,1H383.151c-.331,0-.6-.448-.6-1v-2.629C382.552-76.138,382.82-76.586,383.151-76.586Z",
    transform: "translate(-1 -29.697)",
    fill: "#d0d1d3",
    fillRule: "evenodd"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "video-2",
    "data-name": "video"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_482",
    "data-name": "Path 482",
    d: "M111.419-122H33v62.474h78.419ZM68.475-71.24h7.469v7.809H68.475Zm14.937,0h7.469v7.809H83.412Zm14.937,0h7.469v7.809H98.349Zm-44.811,0h7.469v7.809H53.538Zm-14.937,0H46.07v7.809H38.6ZM68.475-118.1h7.469v7.809H68.475Zm14.937,0h7.469v7.809H83.412Zm14.937,0h7.469v7.809H98.349Zm-44.811,0h7.469v7.809H53.538Zm-14.937,0H46.07v7.809H38.6Z",
    fill: "url(#linear-gradient-9)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_485",
    "data-name": "Path 485",
    d: "M65.886-101.175v23.428l17.708-10.7Z",
    fill: "#fff"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    id: "folder"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_488",
    "data-name": "Path 488",
    d: "M155.134-67.991h-40.95l-9.1-8.536H82.334c-5,0-9.1,3.841-9.1,8.536V-50.92h91v-8.536C164.234-64.15,160.139-67.991,155.134-67.991Z",
    fill: "#fa9500"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_491",
    "data-name": "Path 491",
    d: "M155.134-68.379h-72.8a9.067,9.067,0,0,0-9.1,8.979v44.895a9.067,9.067,0,0,0,9.1,8.979h72.8a9.067,9.067,0,0,0,9.1-8.979V-59.4A9.067,9.067,0,0,0,155.134-68.379Z",
    fill: "url(#linear-gradient-10)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_494",
    "data-name": "Path 494",
    d: "M136.012-43.936A7.527,7.527,0,0,0,143.5-51.5a7.527,7.527,0,0,0-7.487-7.566,7.527,7.527,0,0,0-7.487,7.566A7.527,7.527,0,0,0,136.012-43.936Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_497",
    "data-name": "Path 497",
    d: "M107.215-46.264,88.209-16h38.013Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_500",
    "data-name": "Path 500",
    d: "M136.588-31.133,123.917-13.674h25.342Z",
    fill: "#fff"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    id: "doc"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_503",
    "data-name": "Path 503",
    d: "M127.971-317.447c0,11.447-9.985,11.447-9.985,11.447h-67.4v-87h77.38Z",
    fill: "#d9e9ed"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_505",
    "data-name": "Path 505",
    d: "M62.14-368.891h6.87V-375.6H62.14Z",
    fill: "#00baef"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_507",
    "data-name": "Path 507",
    d: "M75.88-368.891h38.929V-375.6H75.88Z",
    fill: "#00baef"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_509",
    "data-name": "Path 509",
    d: "M62.14-355.474h6.87v-6.709H62.14Z",
    fill: "#00baef"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_511",
    "data-name": "Path 511",
    d: "M75.88-355.474h38.929v-6.709H75.88Z",
    fill: "#00baef"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_513",
    "data-name": "Path 513",
    d: "M62.14-342.057h6.87v-6.709H62.14Z",
    fill: "#00baef"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_515",
    "data-name": "Path 515",
    d: "M75.88-342.057h38.929v-6.709H75.88Z",
    fill: "#00baef"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_518",
    "data-name": "Path 518",
    d: "M113.034-318.18v-12.18H45.971v12.18c0,6.728,3.193,12.18,10.317,12.18h67.063C116.227-306,113.034-311.452,113.034-318.18Z",
    fill: "#c8e8f1"
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    id: "link"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_521",
    "data-name": "Path 521",
    d: "M37.874-384.507l-2.95,2.95a14.022,14.022,0,0,0,.139,19.807,14.022,14.022,0,0,0,19.807.139l2.95-2.95a14.022,14.022,0,0,0-.139-19.807,14.022,14.022,0,0,0-19.807-.139M53.831-368.55l-2.95,2.95A8.412,8.412,0,0,1,39-365.683a8.412,8.412,0,0,1-.083-11.884l2.95-2.95a8.412,8.412,0,0,1,11.884.083,8.412,8.412,0,0,1,.083,11.884",
    fill: "#1976d1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_524",
    "data-name": "Path 524",
    d: "M13.29-359.922l-2.95,2.95a14.022,14.022,0,0,0,.139,19.807,14.022,14.022,0,0,0,19.807.139l2.95-2.95a14.022,14.022,0,0,0-.139-19.807,14.022,14.022,0,0,0-19.807-.139m15.956,15.956-2.95,2.95a8.412,8.412,0,0,1-11.884-.083,8.412,8.412,0,0,1-.083-11.884l2.95-2.95a8.412,8.412,0,0,1,11.884.083,8.412,8.412,0,0,1,.083,11.884",
    fill: "#1976d1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "link-2",
    "data-name": "link",
    d: "M41.178-370.209,23.353-352.384a2.691,2.691,0,0,0-.167,3.794,2.691,2.691,0,0,0,3.794-.167L44.8-366.582a2.691,2.691,0,0,0,.167-3.794,2.692,2.692,0,0,0-3.794.167",
    fill: "#26c3f1"
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "cloud",
    d: "M119.562-383c-10.8,0-19.562-8.512-19.562-19.011s8.758-19.011,19.562-19.011a20.336,20.336,0,0,1,2.38.139A22.448,22.448,0,0,1,143.151-436a22.452,22.452,0,0,1,22.269,19.693,16.879,16.879,0,0,1,1.9-.106A16.7,16.7,0,0,1,184-399.707a16.7,16.7,0,0,1-16.11,16.7v.01H119.562Z",
    transform: "translate(-7 12)",
    fill: "url(#linear-gradient-11)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTracks);
export default __webpack_public_path__ + "static/media/tracks.b23e96d561b312624e3ed85fdf91b41f.svg";
export { ForwardRef as ReactComponent };